import axios from "axios";
import React, { useEffect, useState } from "react";
import { IoIosAdd, IoMdRemove } from "react-icons/io";
import { EVENT_ASSOCIATE_URL, EVENT_SEGMENTS_URL } from '../ApiDetails.js';
import useFormContext from "./useFormContext.js";
import useFormContextFamily from "../GetEventMarsComplete.jsx/useFormMarsComplete.js";

const TotalAttendees = ({familyMode}) => {
    const { eventFormData } = familyMode==="false" ? useFormContext() : useFormContextFamily();
    const [options, setOptions] = useState([]); // Options from API
    const [selectedOption, setSelectedOption] = useState({}); // Track selected options
    const [selectedValue, setSelectedValue] = useState({}); // Track counts for attendees
    const [totalCount, setTotalCount] = useState(0); // Track total attendees count
    const [lists, setLists] = useState([{ lid:0, attendees: "", count: "" }]); // Dynamic rows for attendees

    // Fetch data from API when component mounts
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(EVENT_ASSOCIATE_URL);
                var data = response.data;
                if (Array.isArray(data)) {
                    const adjustedData = data.map((item, index) => ({
                        id: index + 1,
                        name: item,
                    }));
                    setOptions(adjustedData);
                }
                setOptions(data);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        const getTotalAttendees = async () => {
            try {

                const eventId = eventFormData?.eventId;
                if (eventId > 0) {
                    const response = await axios.get(`${EVENT_SEGMENTS_URL}/${eventId}`);
                    const resData = response.data;

                    if (resData.length > 0) {
                        const updateValue = response.data.map((geVal,index) => ({
                            lid: index,
                            attendees: geVal.associateID,
                            count: geVal.attendeesCount,
                        }));
                        setLists(updateValue);

                        const optionData = {};
                        const valueData = {};
                        resData.forEach((item, index) => {
                            optionData[`attendees_${index}`] = item.associateID+1;
                            valueData[`attendeesCount_${index}`] = item.attendeesCount;
                        });
                        setSelectedOption(optionData);
                        setSelectedValue(valueData);
                    }
                }
            } catch (error) {
                console.error("Error in attendees data:", error);
            }
        };
        getTotalAttendees();
    }, [eventFormData?.eventId]);

    // Handle dropdown selection change
    const handleSelectChange = (e, index) => {
        setSelectedOption((prev) => ({
            ...prev,
            [`attendees_${index}`]: e.target.value,
        }));
    };

    // Handle input change for attendees count
    const handleInputChange = (e, index) => {
        setSelectedValue((prev) => ({
            ...prev,
            [`attendeesCount_${index}`]: e.target.value,
        }));
    };

    // Remove row
    const removeItem = (index1) => {
        var updated = [ ...lists ];
        var nbOptions = lists.length;
        updated.splice(index1, 1);

        const newValue = { ...selectedValue };
        const newOption = { ...selectedOption };
        for (var i=index1;i<nbOptions;i++) {
            newOption[`attendees_${i}`] = newOption[`attendees_${i+1}`];
            newValue[`attendeesCount_${i}`] = newValue[`attendeesCount_${i+1}`];
        }
        delete newOption[`attendees_${nbOptions-1}`];
        delete newValue[`attendeesCount_${nbOptions-1}`];

        setLists(updated);
        setSelectedOption(newOption);
        setSelectedValue(newValue);
        updateValue();
    };

    // Add a new row
    const increase = () => {
        setLists([...lists, { lid: lists.count, attendees: "", count: "" }]);
    };

    // Update total attendees count
    const updateValue = () => {
        const sumOfAttendees = Object.values(selectedValue)
            .map(Number)
            .reduce((acc, curr) => acc + curr, 0);
        setTotalCount(sumOfAttendees);
    };

    useEffect(() => {
        updateValue();
    }, [selectedValue]);

    // Save the data
    const handleSave = async () => {
        try {
            const eventId = eventFormData?.eventId;
            if (eventId > 0) {
                const postDatas = lists.map((listItem, index) => {
                    return {
                        id: 0,
                        eventId: Number(eventFormData?.eventId) || 0,
                        associateID: parseInt(selectedOption[`attendees_${index}`], 10)-1,
                        attendeesCount: parseInt(selectedValue[`attendeesCount_${index}`], 10),
                        createdDate: new Date().toISOString(),
                        updatedDate: new Date().toISOString(),
                    };
                });
                
                await axios.delete(`${EVENT_SEGMENTS_URL}/${eventId}`);
                for (const data of postDatas) {
                    await axios.post(EVENT_SEGMENTS_URL, data)
                }
                alert("Total attendees saved successfully");
            }
        } catch (error) {
            console.error("Error saving data:", error);
        }
    };

    return (
        <div>
            <div className="row">
                <div className="col-2">
                    <h4 className="pagetitle">Total Attendees</h4>
                </div>
                <div className="col-3">
                    <h4 className="pagetitle">{totalCount}</h4>
                </div>
                <div className="col-6"></div>
            </div>

            {lists.map((item, index) => (
                <div
                    key={item.lid}
                    className="row p-1 row-cols-sm-auto g-2 bg-light mt-2 align-items-center"
                >
                    <div className="col-1">
                        <button
                            onClick={() => removeItem(index)}
                            type="button"
                            className="btn remove-btn btn-sm"
                        >
                            <IoMdRemove />
                        </button>
                    </div>
                    <div className="col-4">
                        <select
                            className="custom-font-lt form-control form-select"
                            value={selectedOption[`attendees_${index}`] || "select"}
                            name={`attendees_${index}`}
                            onChange={(e) => handleSelectChange(e, index)}
                        >
                            <option value="select" disabled>
                                Select
                            </option>
                            {options.map((option, idx) => (
                                <option key={idx} value={idx + 1}>
                                    {option}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-4">
                        <input
                            className="custom-font-lt form-control"
                            name={`attendeesCount_${index}`}
                            onChange={(e) => handleInputChange(e, index)}
                            value={selectedValue[`attendeesCount_${index}`]}
                        />
                    </div>
                </div>
            ))}

            <div className="row mt-3">
                <div className="col-5">
                    <button
                        onClick={increase}
                        type="button"
                        className="btn remove-btn btn-sm me-3"
                    >
                        <IoIosAdd width={20} height={20} /> Add Segment Count
                    </button>
                    <button
                        type="button"
                        className="btn btn-save p-2"
                        onClick={handleSave}
                    >
                        SAVE
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TotalAttendees;